import { useState, useEffect } from "react";
import { auth, functions, fb } from "../../firebase";
import styles from "./styles.module.css";
import { Link, Route } from "react-router-dom";
import { useHistory, useLocation } from "react-router-dom";
import { FcGoogle } from "react-icons/fc";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const history = useHistory();

  const handleLogin = () => {
    auth
      .signInWithEmailAndPassword(email, password)
      .then(() => {
        history.push("/home");
      })
      .catch(() => {
        alert("Sorry, wrong email or password");
      });
  };

  const handleGoogleLogin = () => {
    const provider = new fb.auth.GoogleAuthProvider();
    auth
      .signInWithPopup(provider)
      .then((result) => {
        const { credential, user } = result;
        const token = credential.accessToken;

        // save token and refresh token to user document
        // const { refreshToken, uid } = user;

        history.push("/home");
      })
      .catch((error) => {
        const {code, message, email, credential } = error;
        console.log(error);
      });
  }

  const resetLocation = () =>  ({
    pathname: "/auth/reset",
    state: { email: email }
  })

  return (
    <div className={styles.authContainer}>
      <div className={styles.containerTitle}>Login</div>
      <div style={{ marginTop: 20 }}>
        <div>Email</div>
        <input
          className={"input"}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </div>
      <div style={{ marginTop: 20 }}>
        <div>Password</div>
        <input
          type="password"
          className={"input"}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
      </div>
      <div>
        <button className={styles.authButton} onClick={handleLogin}>
          Login
        </button>
        <button className={styles.googleButton} onClick={handleGoogleLogin}>
          <div className={styles.googleIcon}>
          <FcGoogle size="1.5em" />
          </div>
          Sign in with Google
        </button>
      </div>
      <div style={{ marginTop: 20 }}>
        Forgot Password?{" "}
        <Link className={styles.navLink} to={resetLocation()}>
          Reset
        </Link>
      </div>
    </div>
  );
};
